import React, { useState } from "react";
import emailjs from "emailjs-com";

export default function AddReview() {
  const [name, setName] = useState("");
  const [text, setText] = useState("");
  const [rating, setRating] = useState(5);
  const [loading, setLoading] = useState(false);

  const submitReview = () => {
    if (!name.trim() || !text.trim()) {
      alert("Please enter your name and review");
      return;
    }

    setLoading(true);

    emailjs
      .send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_REVIEW_TEMPLATE_ID,
        {
          name,
          rating,
          text,
        },
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      )
      .then(() => {
        alert("Thank you! Your review will be published after approval.");
        setName("");
        setText("");
        setRating(5);
      })
      .catch(() => {
        alert("Failed to submit review. Please try again.");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <section className="py-20 md:py-28">
      <div className="max-w-xl mx-auto px-6 text-center">
        <h1 className="section-heading mb-8">Add Your Review</h1>

        {/* Name */}
        <input
          type="text"
          className="input-weddmac mb-4"
          placeholder="Your name"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />

        {/* Rating */}
        <select
          className="input-weddmac mb-4"
          value={rating}
          onChange={(e) => setRating(Number(e.target.value))}
        >
          {[5, 4, 3, 2, 1].map((n) => (
            <option key={n} value={n}>
              {n} Stars
            </option>
          ))}
        </select>

        {/* Review */}
        <textarea
          className="input-weddmac mb-4"
          rows="4"
          placeholder="Share your experience with us…"
          value={text}
          onChange={(e) => setText(e.target.value)}
        />

        <button
          onClick={submitReview}
          className="btn-primary w-full"
          disabled={loading}
        >
          {loading ? "Submitting..." : "Submit Review"}
        </button>
      </div>
    </section>
  );
}
